export default "__VITE_ASSET__C8C3zjZM__"